<template>
  <div class="application-component"
       v-if="formDescriptors.length">
    <!-- Title -->
    <div class="columns">
      <div class="column is-12">
        <title-component
          class="is-uppercase"
          :size="layout.title_size"
          :lineSeparator="layout.title_line_separator">
          {{ title }}
        </title-component>
        <!-- Description -->
        <div class="subtitle is-6">{{ description }}</div>
      </div>
    </div>

    <!-- Forms -->
    <template v-if="formDescriptors && formDatas">
      <form-component
        v-for="formDescriptor in formDescriptors"
        :formDescriptor="formDescriptor"
        :formData="getFormDataForDescriptor(formDescriptor)"
        :key="formDescriptor.id">
      </form-component>
    </template>

    <!-- Buttons -->
    <div class="field is-grouped">
      <p class="control">
        <submit-btn-component class="is-primary is-large is-uppercase" @submit="saveApplication" :group="'btnGroup'" v-translate>Send in application</submit-btn-component>
      </p>
      <p class="control">
        <submit-btn-component class="button is-danger is-outlined is-large" @submit="$router.push({ name: 'WelcomeView' })" :group="'btnGroup'" v-translate>
          Cancel
        </submit-btn-component>
      </p>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import FormComponent from '@/components/form/FormComponent'
  import { formHandlerMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'

  let VueScrollTo = require('vue-scrollto')

  export default {
    name: 'application-component',
    mixins: [formHandlerMixin, setContainedHeightMixin],
    directives: {
      VueScrollTo
    },
    data () {
      return {
        submitRequest: null
      }
    },
    props: {
      code: {
        required: true
      }
    },
    components: {
      FormComponent,
      TitleComponent,
      SubmitBtnComponent
    },
    computed: {
      ...mapState({
        title: state => state.formModule.title,
        description: state => state.formModule.description,
        layout: state => state.formModule.layout,
        formDescriptors: state => state.formModule.formDescriptors,
        formDatas: state => state.formModule.formDatas,
        service: state => state.formModule.service
      })
    },
    methods: {
      ...mapActions([
        'setupApplicationForm',
        'saveApplicationForm',
        'clearData',
        'successMessage'
      ]),
      saveApplication (btn) {
        let requestData = {
          formDatas: this.formDatas,
          service: this.service
        }
        this.submitRequest = this.saveApplicationForm
        this.submitForm(requestData, btn, this.saveApplicationCallback)
      },
      saveApplicationCallback (response) {
        this.successMessage(this.$ngettext('Application sent'))
        this.$router.push({ name: 'ThankYouView', params: { email: response.data.email } })
      },
      setupForm () {
        this.setupApplicationForm(this.code).then(() => {
          this.setContainedHeight()
        }).catch((err) => {
          this.handleError(err)
        })
      }
    },
    created () {
      this.setupForm()
      this.$root.$on('languageChanged', this.setupForm)
    },
    beforeDestroy () {
      this.clearData()
    }
  }
</script>

<style lang="sass" scoped>
</style>
